import React, { useEffect, useState } from "react";
import LastDiscipLearning from "../../components/lastDiscipLearning/LastDiscipLearning.jsx";
import {
  ErrataWidget,
  ProgressWidget,
  WidgetFrame,
  WidgetGrid,
  WidgetGridModel,
  AddWidget,
  Locale,
} from "../../../personal-studio-components/studio/index.js";
import ModalZetLessons from "../../components/modalZetLessons/ModalZetLessons";
import AcademicDept from "../../components/academicDept/AcademicDept.jsx";
import CalendarLessonDetail from "../../components/calendarLessonDetail/CalendarLessonDetail.jsx";
import BurnDownData from "../../components/burnDownData/BurnDownData.jsx";
import ContractPaymentDebt from "../../components/ContractPaymentDebt/ContractPaymentDebt.jsx";
import CalendarGraphicWidget from "../../components/calendarGraphic/CalendarGraphicWidget.jsx";
import Promo from "../../components/Promo/Promo.jsx";
import { useSelector } from "react-redux";
import { StudentService } from "../../components/studentService";

function Widgets() {
  const { contractId } = useSelector((state) => state.contract);
  const { access_token } = useSelector((state) => state.token);
  const request = {
    method: "post",
    path: "/dashboard/disposition/load",
    data: {
      access_token,
      study_contract_id: contractId,
    },
  };
  const [response, setResponse] = useState(null);
  useEffect(() => {
    StudentService.send(request, setResponse);
  }, [access_token, contractId]);
  if (!response) return <ProgressWidget title="Загрузка виджетов..." />;
  if (response.errors) return <ErrataWidget errata={response} />;
  const model = new WidgetGridModel({
    prefix: "/personal-studio/",
    contract_id: contractId,
    widget: {
      Promo: <Promo menu={[getHideAction("Promo")]} />,
      CalendarGraphic: (
        <CalendarGraphicWidget menu={[getHideAction("CalendarGraphic")]} />
      ),
      CalendarLessonDetail: (
        <WidgetFrame
          title="Календарь"
          icon="calendar"
          type="yellow"
          menu={[getHideAction("CalendarLessonDetail")]}
        >
          <CalendarLessonDetail />
        </WidgetFrame>
      ),
      AcademicDept: <AcademicDept menu={[getHideAction("AcademicDept")]} />,
      ContractPaymentDebt: (
        <ContractPaymentDebt
          hasPaymentBtn
          menu={[getHideAction("ContractPaymentDebt")]}
        />
      ),
      BurnDownData: (
        <WidgetFrame
          title="Динамика освоения образовательной программы"
          icon="graph"
          type="magenta"
          menu={[getHideAction("BurnDownData")]}
        >
          <BurnDownData />
        </WidgetFrame>
      ),
      LastDiscipLearning: (
        <LastDiscipLearning menu={[getHideAction("LastDiscipLearning")]} />
      ),
    },
    grid: [
      {
        id: "Promo",
        visible: true,
        colspan: 3,
        minHeight: "9.375rem",
        height: "9.375rem",
        maxHeight: "9.375rem",
      },
      {
        id: "CalendarGraphic",
        visible: true,
        colspan: 2,
        minHeight: "6.875rem",
      },
      {
        id: "CalendarLessonDetail",
        visible: true,
        colspan: 1,
        minHeight: "34rem",
      },
      {
        id: "AcademicDept",
        visible: true,
        colspan: 2,
        minHeight: "10rem",
      },
      {
        id: "ContractPaymentDebt",
        visible: true,
        colspan: 1,
        minHeight: "27rem",
      },
      {
        id: "BurnDownData",
        visible: true,
        colspan: 2,
        minHeight: "32rem",
      },
      {
        id: "LastDiscipLearning",
        visible: true,
        colspan: 3,
        height: "25rem",
        minHeight: "14rem",
      },
      {
        id: "AddWidget",
        visible: true,
        colspan: 1,
        minHeight: "6.875rem",
      },
    ],
  });
  model.widget["AddWidget"] = (
    <AddWidget widget_grid={model} locale={locale} onSubmit={onSubmit} />
  );

  model.merge({ grid: response });
  const hasPromo =
    Array.isArray(response) && response.some((w) => w.id === "Promo");
  if (!hasPromo) {
    const i = model.indexOf("Promo");
    if (i >= 0) model.grid.splice(i, 1);
  }
  return (
    <ModalZetLessons>
      <WidgetGrid {...model} onSave={debounce(onSave, 1000)} />
    </ModalZetLessons>
  );
  function onSave(model) {
    const request = {
      method: "post",
      path: "/dashboard/disposition/save",
      data: {
        access_token,
        study_contract_id: contractId,
        data: model.grid,
      },
    };
    StudentService.send(request, (response) => {});
  }
  function onSubmit(model) {
    setResponse([...model.grid]);
    onSave(model);
  }
  function getHideAction(widget_id) {
    return {
      name: "Скрыть",
      onClick: (event) => {
        event.preventDefault();
        const index = model.indexOf(widget_id);
        model.grid[index].visible = false;
        onSubmit(model);
      },
    };
  }
}
function debounce(callback, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      callback.apply(this, args);
    }, timeout);
  };
}
/**
 * Локализация модуля.
 * @type {Locale}
 * @private
 */
const locale = new Locale("Widgets", {
  Promo: "Акции",
  LastDiscipLearning: "Последние действия",
  CalendarLessonDetail: "Календарь",
  AcademicDept: "Академическая разница",
  ContractPaymentDebt: "Ваш баланс",
  BurnDownData: "Динамика освоения образовательной программы",
  CalendarGraphic: "Планирование",
  AddWidget: "Добавить виджет",
});
export default Widgets;
